import React from 'react';
import { StockXGoldTheme, ConfirmModalProvider } from '@stockx/ui';
import { RequestProvider, HostProvider } from '@app/request';
import { RumProvider } from '@app/rum';
import { DeviceProvider, NonInteractiveViewerProvider } from '@app/ui';
import { FraudProvider } from '@app/fraud';
import { RecoilProvider } from '@app/recoil';

import { ProviderProps } from '@app/shell/types';

import { SegmentProvider } from '@app/segment';
import { AnalyticsProvider } from '@app/analytics';
import { RoktLauncherProvider } from '@app/rokt';

import ExperimentsProvider from './components/ExperimentsProvider';
import UserProvider from './components/UserProvider';
import HeaderProvider from './components/HeaderProvider';
import ReactQueryProvider from './components/ReactQueryProvider';
import CookieProvider from './components/CookieProvider';
import I18nProvider from './components/I18nProvider';
import ApolloProvider from './components/ApolloProvider';
import HelmetProvider from './components/HelmetProvider';

import ReduxDataHydrateProvider from './components/ReduxDataHydrateProvider';
import ReduxProvider from './components/ReduxProvider/ReduxProvider';

const IsomorphicProviders = ({ children, req }: ProviderProps) => (
  <ReduxProvider req={req}>
    <ReduxDataHydrateProvider>
      <ExperimentsProvider req={req}>
        <AnalyticsProvider>
          <ApolloProvider req={req}>
            <HelmetProvider req={req}>
              <CookieProvider req={req}>
                <StockXGoldTheme>
                  <I18nProvider req={req}>
                    <RecoilProvider req={req}>
                      <ReactQueryProvider req={req}>
                        <ConfirmModalProvider>
                          <UserProvider>
                            <DeviceProvider req={req}>
                              <NonInteractiveViewerProvider req={req}>
                                <HeaderProvider>
                                  <RequestProvider req={req}>
                                    <HostProvider req={req}>
                                      <FraudProvider>
                                        <RumProvider>
                                          <SegmentProvider>
                                            <RoktLauncherProvider>
                                              {children}
                                            </RoktLauncherProvider>
                                          </SegmentProvider>
                                        </RumProvider>
                                      </FraudProvider>
                                    </HostProvider>
                                  </RequestProvider>
                                </HeaderProvider>
                              </NonInteractiveViewerProvider>
                            </DeviceProvider>
                          </UserProvider>
                        </ConfirmModalProvider>
                      </ReactQueryProvider>
                    </RecoilProvider>
                  </I18nProvider>
                </StockXGoldTheme>
              </CookieProvider>
            </HelmetProvider>
          </ApolloProvider>
        </AnalyticsProvider>
      </ExperimentsProvider>
    </ReduxDataHydrateProvider>
  </ReduxProvider>
);

export default IsomorphicProviders;
